@if (collections.length > 0) {
  @if (isMasonry()) {
    <ngx-masonry [options]="masonryOptions" [ordered]="true">
      <div class="grid-sizer w-full sm:w-[50%] md:w-[25%] lg:w-[20%]"></div>
      @for (item of collections; track item) {
        <div class="masonry-item w-full sm:w-[50%] md:w-[25%] lg:w-[20%]" ngxMasonryItem>
          <aipb-simple-card (click)="action.emit(item)" [label]="item.label" class="cursor-pointer">
            @if (item.recordsCount > 0) {
              <div class="px-3 pb-3" simple-card-subheader>
                <span class="mr-1">{{ item.recordsCount }}</span>
                <fa-icon [icon]="recordCountIcon" size="sm"></fa-icon>
              </div>
            }
            @if (item.images.length > 2) {
              <dg-collection-cover
                [defaultImage]="defaultImage"
                [images]="item.images"
              ></dg-collection-cover>
            }
            @if (item.images.length > 0 && item.images.length <= 2) {
              <img
                [defaultImage]="defaultImage"
                [lazyLoad]="item.images[0].thumb"
                [src]="item.images[0]"
                />
            }
            @if (item.sublabel) {
              <div class="p-2">{{ item.sublabel }}</div>
            }
          </aipb-simple-card>
        </div>
      }
    </ngx-masonry>
  }
  @if (isList()) {
    <aipb-simple-card>
      <mat-action-list class="pt-0">
        @for (item of collections; track item) {
          <button (click)="action.emit(item)" mat-list-item>
            <img [alt]="item.label" [src]="item.images[0]" matListItemAvatar />
            @if (item.label) {
              <h3 matListItemTitle>{{ item.label }}</h3>
            }
            @if (item.sublabel) {
              <p matListItemLine>
                <span> {{ item.sublabel }} </span>
              </p>
            }
          </button>
        }
      </mat-action-list>
    </aipb-simple-card>
  }
}
